var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"as-employee-com",on:{"click":function($event){return _vm.handleClick()}}},[_c('div',{staticClass:"employee-lbl-icon"},[_c('div',[_c('Icon',{attrs:{"name":_vm.getItemIcon()}})],1),(_vm.labelShow)?_c('div',{staticClass:"as-employee-label"},[_c('span',[_vm._v(_vm._s(_vm.commitment))])]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }